var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-main",
    {
      staticClass: "admin-edit admin-edit-media",
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _c("h1", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _c("k-actions", {
                    staticClass: "header-actions",
                    attrs: { actions: _vm.actions, icons: _vm.icons },
                    on: { exec: _vm.doAction },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [{ name: "bar", rawName: "v-bar" }],
          staticClass: "main-content",
        },
        [
          _c(
            "div",
            { staticClass: "inner" },
            [
              _c("f-string", {
                attrs: { label: "Title", value: _vm.formData.title || "" },
                on: {
                  input: function ($event) {
                    return _vm.update($event, "title")
                  },
                },
              }),
              _c(
                "section",
                [_c("k-video-player", { attrs: { content: _vm.postData } })],
                1
              ),
              _c(
                "section",
                [
                  _c("f-text", {
                    attrs: {
                      label: "Caption",
                      value: _vm.formData.caption || "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.update($event, "caption")
                      },
                    },
                  }),
                  _c("f-text", {
                    attrs: {
                      label: "Description",
                      value: _vm.formData.description || "",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.update($event, "description")
                      },
                    },
                  }),
                  _c("f-collections", {
                    attrs: {
                      label: "In collections",
                      value: _vm.formData.collections,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.update($event, "collections")
                      },
                    },
                  }),
                  _c("f-tags", {
                    attrs: {
                      label: "Tags",
                      value: _vm.formData.attachment_tag,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.update($event, "tags")
                      },
                    },
                  }),
                  _c("f-content-restrictions", {
                    attrs: { value: _vm.formData.restrictions },
                    on: {
                      input: function ($event) {
                        return _vm.update($event, "restrictions")
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("k-actions", {
        staticClass: "footer-actions",
        attrs: { actions: _vm.actions, icons: _vm.icons, type: "icon-text" },
        on: { exec: _vm.doAction },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }